import type { SupabaseClient } from '@supabase/supabase-js'
import { getSupabaseClient } from '../supabase/client'

export interface UserAccessProfile {
  isAdmin: boolean
  email: string | null
}

type AccessProfileClient = Pick<SupabaseClient, 'rpc'>
type ClientLoader = () => Promise<AccessProfileClient>

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export async function getMyAccessProfile(
  loadClient: ClientLoader = getSupabaseClient,
): Promise<UserAccessProfile> {
  const client = await loadClient()
  const { data, error } = await client.rpc('get_my_access_profile')
  if (error) throw new Error('Unable to verify developer access.')

  const row = Array.isArray(data) ? data[0] : data
  if (!isRecord(row) || typeof row.is_admin !== 'boolean') {
    throw new Error('Supabase returned an invalid access profile.')
  }

  return {
    isAdmin: row.is_admin === true,
    email: typeof row.email === 'string' ? row.email : null,
  }
}
